<template>
    <div class="end-screen">
        <img
            src="/apotheke_clean_02-voll.png"
            alt="Apotheke"
            class="pharmacy-background"
        />
        <div class="end-card">
            <h1 class="end-title">Gut gemacht!</h1>
            <div class="score-subtitle">Dein Ergebnis:</div>
            <div class="final-score">{{ score }}</div>
            <button
                class="replay-button"
                @click="emit('restart')"
            >
                Nochmal spielen
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
    defineProps<{
        score: number;
    }>();

    const emit = defineEmits<{
        restart: [];
    }>();
</script>

<style scoped>
    .end-screen {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        box-sizing: border-box;
    }

    .pharmacy-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
        z-index: 1;
    }

    .end-card {
        position: relative;
        z-index: 2;
        background: #007f96;
        border-radius: 24px;
        padding: 30px 20px;
        text-align: center;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        animation: slideIn 0.5s ease-out;
        max-width: 380px;
        color: #fff;
    }

    .end-title {
        color: #fff;
        font-size: 40px;
        font-weight: 700;
        margin: 0 0 26px 0;
    }

    .score-subtitle {
        color: #fff;
        font-size: 25px;
        font-weight: 500;
        margin: 8px 0 10px 0;
    }

    .final-score {
        color: #fff;
        font-size: 64px;
        font-weight: 900;
        margin: 0;
        line-height: 1;
    }

    .replay-button {
        background: #b81580;
        color: white;
        border: none;
        padding: 14px 36px;
        font-size: 27px;
        font-weight: 600;
        border-radius: 12px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: 0;
        margin-top: 38px;
    }

    .replay-button:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 24px rgba(247, 148, 29, 0.6);
    }

    .replay-button:active {
        transform: translateY(0);
    }

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-30px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }
</style>
